<script setup>
import { ref, onMounted, onUnmounted, defineExpose, nextTick } from 'vue'
import {useRouter} from "vue-router";
const router = useRouter();

const products = ref([])
const getNClass = (index) => {
  const classes = ['n0', 'n1', 'n2', 'n3']
  return classes[index % 4]
}
const info = ref({})
let observer = null

function getInfo (e,data) {
  products.value = e
  info.value = data

  // 数据更新后重新设置观察器
  nextTick(() => {
    setTimeout(() => {
      setupObserver()
    }, 100)
  })
}

function setupObserver() {
  if (observer) {
    observer.disconnect()
  }

  observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate__fadeInUp');
            observer.unobserve(entry.target);
          }
        })
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      }
  )

  // 确保元素已渲染后再观察
  const elements = document.querySelectorAll('#floor_1_main .gridlist1 li')
  elements.forEach((el) => {
    observer.observe(el)
  })
}

function goDetails(item) {
  router.push({
    path: `/productDetails`,
    query: { id: item.id }
  })
}

onMounted(() => {
  // 组件挂载后初始化观察器
  nextTick(() => {
    setTimeout(() => {
      setupObserver()
    }, 100)
  })
})

onUnmounted(() => {
  if (observer) {
    observer.disconnect()
  }
})

defineExpose({
  getInfo
})
</script>

<template>
  <div id="floor_1_main">
    <div id="floor_1">
      <div class="left_title1">
        <h2><a href="javascript:;">{{info.name}}</a></h2>
        <p>{{info.remark}} </p>
        <i></i>
      </div>
      <div class="left_body1">
        <ul class="gridlist1">
          <!-- 使用 v-for 循环渲染 -->
          <li
              v-for="(product, index) in products"
              :key="product.id"
              :class="getNClass(index)"
              class="animate__animated  "
              @click="goDetails(product)"
          >
            <div
                class="InfoPicture pointer"

            >
              <img
                  :src="product.picUrl"
                  :title="product.title"
                  :alt="product.title"
              />
            </div>
            <div class="InfoTitle">
              <span
                  :href="`/yccms/product/details/10/ $ {product.id}.html`"
                  target="_blank"
              >
                {{ product.title }}
              </span>
            </div>
          </li>
        </ul>
      </div>
      <div class="left_bottom1"></div>
    </div>
  </div>
</template>

<style scoped lang="scss">
/* 可选：初始隐藏，让动画更明显 */
#floor_1_main .gridlist1 li {
  opacity: 0;                    // 初始隐藏
  transform: translateY(30px);   // 初始位置向下偏移

  &.animate__fadeInUp {
    opacity: 1;
    transform: translateY(0);
    animation-name: fadeInUp;
    animation-duration: 0.6s;
  }
}
</style>